import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

const UserDetailsModal = ({
  isViewDetailsOpen,
  closeDetailsModal,
  selectedUserId,
}) => {
  const [user, setUser] = useState(null);
  const { users } = useSelector((state) => state.users);

  useEffect(() => {
    const selectedUser = users?.find((user) => user?.id == selectedUserId);
    setUser(selectedUser);
  }, [selectedUserId]);

  return (
    <Modal
      show={isViewDetailsOpen}
      onHide={isViewDetailsOpen}
      centered
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">User Details</h5>
        <button
          type="button"
          className="btn-close"
          onClick={closeDetailsModal}
        ></button>
      </div>
      <div className="modal-body">
        <table className="table table-borderless">
          <tbody>
            <tr>
              <td>
                <span className="fw-semibold">Name: </span>
                <span>{user?.name}</span>
              </td>
              <td>
                <span className="fw-semibold">Gender: </span>
                <span>{user?.gender}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Age: </span>
                <span>{user?.age}</span>
              </td>
              <td>
                <span className="fw-semibold">Date of Birth: </span>
                <span>{user?.dob}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Country: </span>
                <span>{user?.country}</span>
              </td>
              <td>
                <span className="fw-semibold">City: </span>
                <span>{user?.city}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Minor: </span>
                <span>{user?.isMinor ? 'Yes' : 'No'}</span>
              </td>
              <td>
                <span className="fw-semibold">Stringer: </span>
                <span>{user?.stringer == true ? "Yes" : "No"}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Reliability: </span>
                <span>{user?.reliabilityNum}</span>
              </td>
              <td>
                <span className="fw-semibold">User ID: </span>
                <span>{user?.id}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default UserDetailsModal;